/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */
import { DecisionPoint } from './decision.point';

export enum WorkType {
  NONE         = 0,
  MEGABLOCK    = 1,
  CONSTRUCTION = 2,
}

/**
 *
 * @class WorkBlock
 *
 * @brief base model for active work zones during a simulation run, mega block or construction;
 * basically times when trains can't pass through a given area of the network, because the tracks
 * are crawling with humanz.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2020
 *
 */
export class WorkBlock {

  /** @var number the unique id of this work block */
  public             _id: number              = -1;

  /** @var string user label for block */
  public            _name: string             = '';

  /** @var string user description for block */
  public     _description: string             = '';

  /** @var DecisionPoint|null the decision point on west side of work */
  public            _from: DecisionPoint|null = null;

  /** @var DecisionPoint|null the decision point on east side of work */
  public              _to: DecisionPoint|null = null;

  /** @var number[] the days when active work is done (start/duration is same on each) */
  public            _days: number[]           = [];

  /** @var number the second when work starts (within a day) */
  public           _start: number             = 0;

  /** @var number the seconds amount of work (within a day) */
  public        _duration: number             = 0;

  /** @var WorkType the kind of work block */
  public            _type: WorkType           = WorkType.NONE;

  /** @var number zero based index for this item */
  public             _nth: number             = -1;

  /** @brief standard constructor */
  constructor(      id: number,
                  from: DecisionPoint|null,
                    to: DecisionPoint|null,
                  days: number[],
                 start: number,
              duration: number,
                  type: WorkType,
                  name: string,
           description: string,
                   nth: number) {

    this._id          = id;
    this._from        = from;
    this._to          = to;
    this._days        = days;
    this._start       = start;
    this._duration    = duration;
    this._type        = type;
    this._name        = name;
    this._description = description;
    this._nth         = nth;
  }

  /** @brief convert track type to a string */
  public static typeToString(type: WorkType): string {

    switch (type) {
      case WorkType.NONE:         return 'N';
      case WorkType.MEGABLOCK:    return 'M';
      case WorkType.CONSTRUCTION: return 'C';
    }

    return '';
  }

  /* convert to string summary */
  public asString(): string {

    return '#' + this._id + ' ' + WorkBlock.typeToString(this._type) + ' ' + this._name;
  }

  /** @brief convert track string to a type */
  public static typeFromString(type: string): WorkType {

    const tmp: string = type.toLowerCase().trim();

    if ((tmp === 'n') || (tmp === '')) {

      return WorkType.NONE;

    } else if ((tmp === 'm') || (tmp === 'megablock')) {

      return WorkType.MEGABLOCK;

    } else if ((tmp === 'c') || (tmp === 'construction')) {

      return WorkType.CONSTRUCTION;

    }

    return WorkType.NONE;
  }

}
